/* eslint-disable */
// @generated by protobuf-ts 2.8.2 with parameter generate_dependencies,add_pb_suffix,use_proto_field_name,ts_nocheck,eslint_disable
// @generated from protobuf file "brandguard.kernel.proto" (package "brandguard.kernel", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.KernelMetadata
 */
export interface KernelMetadata {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string version = 2;
     */
    version: string;
    /**
     * @generated from protobuf field: string account_id = 3 [json_name = "account_id"];
     */
    account_id: string;
    /**
     * @generated from protobuf field: string brand_id = 4 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: string name = 6;
     */
    name: string;
    /**
     * @generated from protobuf field: string mimetype = 5;
     */
    mimetype: string;
    /**
     * @generated from protobuf field: string created_at = 8 [json_name = "created_at"];
     */
    created_at: string;
    /**
     * @generated from protobuf field: string updated_at = 9 [json_name = "updated_at"];
     */
    updated_at: string;
    /**
     * @generated from protobuf field: brandguard.kernel.Status status = 10;
     */
    status: Status;
    /**
     * @generated from protobuf field: string settings_md5 = 11 [json_name = "settings_md5"];
     */
    settings_md5: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.KernelNameUpdateRequest
 */
export interface KernelNameUpdateRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.KernelNameUpdateResponse
 */
export interface KernelNameUpdateResponse {
    /**
     * @generated from protobuf field: brandguard.kernel.KernelMetadata kernel = 1;
     */
    kernel?: KernelMetadata;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.TextKernelScoringEnabled
 */
export interface TextKernelScoringEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.TextKernelScoringToneAndVoice
 */
export interface TextKernelScoringToneAndVoice {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string prompt = 2;
     */
    prompt: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.TextKernelScoringGrammar
 */
export interface TextKernelScoringGrammar {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: brandguard.kernel.GrammarProvider provider = 2;
     */
    provider: GrammarProvider;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.TextKernelScoringProfanity
 */
export interface TextKernelScoringProfanity {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: brandguard.kernel.ProfanityProvider provider = 2;
     */
    provider: ProfanityProvider;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.TextKernelScoringRacism
 */
export interface TextKernelScoringRacism {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: brandguard.kernel.RacismProvider provider = 2;
     */
    provider: RacismProvider;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.TextKernelReferenceRule
 */
export interface TextKernelReferenceRule {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string; // md5 of the rule
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: string rule = 3;
     */
    rule: string;
    /**
     * @generated from protobuf field: string explanation = 4;
     */
    explanation: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.TextKernelReferenceRulesEnabled
 */
export interface TextKernelReferenceRulesEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.TextKernelReferenceRule rules = 2;
     */
    rules: TextKernelReferenceRule[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.TextKernelProductDetection
 */
export interface TextKernelProductDetection {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.TextKernelSetting
 */
export interface TextKernelSetting {
    /**
     * @generated from protobuf field: string id = 1 [json_name = "kernel_id"];
     */
    id: string;
    /**
     * @generated from protobuf field: int32 threshold = 2;
     */
    threshold: number;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelScoringEnabled brand_voice = 3 [json_name = "brand_voice"];
     */
    brand_voice?: TextKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelScoringProfanity profanity = 4;
     */
    profanity?: TextKernelScoringProfanity;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelScoringRacism racism = 5;
     */
    racism?: TextKernelScoringRacism;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelScoringToneAndVoice tnv = 6;
     */
    tnv?: TextKernelScoringToneAndVoice;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelScoringEnabled emotions = 7;
     */
    emotions?: TextKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelScoringGrammar grammar = 8;
     */
    grammar?: TextKernelScoringGrammar;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelReferenceRulesEnabled reference_rules = 9 [json_name = "reference_rules"];
     */
    reference_rules?: TextKernelReferenceRulesEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelScoringEnabled brand_consistency = 10 [json_name = "brand_consistency"];
     */
    brand_consistency?: TextKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelProductDetection product_detection = 11 [json_name = "product_detection"];
     */
    product_detection?: TextKernelProductDetection;
    /**
     * @generated from protobuf field: brandguard.kernel.TextKernelScoringEnabled ai_generated = 12 [json_name = "ai_generated"];
     */
    ai_generated?: TextKernelScoringEnabled;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelScoringEnabled
 */
export interface ImageKernelScoringEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelScoringToneAndVoice
 */
export interface ImageKernelScoringToneAndVoice {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string prompt = 2;
     */
    prompt: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageClearspace
 */
export interface ImageClearspace {
    /**
     * @generated from protobuf field: double horizontal = 1;
     */
    horizontal: number;
    /**
     * @generated from protobuf field: double vertical = 2;
     */
    vertical: number;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelLogo
 */
export interface ImageKernelLogo {
    /**
     * @generated from protobuf field: string mimetype = 1;
     */
    mimetype: string;
    /**
     * @generated from protobuf field: string md5 = 2;
     */
    md5: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string image = 4;
     */
    image: string; // these should be bytes but we have to base64 encode to deal with javascript stupidity.
    /**
     * @generated from protobuf field: brandguard.kernel.ImageClearspace clearspace = 5;
     */
    clearspace?: ImageClearspace;
    /**
     * @generated from protobuf field: string usage = 6;
     */
    usage: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelLogosEnabled
 */
export interface ImageKernelLogosEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.ImageKernelLogo logos = 2;
     */
    logos: ImageKernelLogo[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelBackgroundColor
 */
export interface ImageKernelBackgroundColor {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string color = 2;
     */
    color: string; // hexadecimal string representing color
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string usage = 4;
     */
    usage: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelBackgroundColorEnabled
 */
export interface ImageKernelBackgroundColorEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.ImageKernelBackgroundColor colors = 2;
     */
    colors: ImageKernelBackgroundColor[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelFont
 */
export interface ImageKernelFont {
    /**
     * @generated from protobuf field: string md5 = 1;
     */
    md5: string;
    /**
     * @generated from protobuf field: string mimetype = 2;
     */
    mimetype: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string font = 4;
     */
    font: string;
    /**
     * @generated from protobuf field: bool style_regular = 5 [json_name = "style_regular"];
     */
    style_regular: boolean;
    /**
     * @generated from protobuf field: bool style_bold = 6 [json_name = "style_bold"];
     */
    style_bold: boolean;
    /**
     * @generated from protobuf field: bool style_italic = 7 [json_name = "style_italic"];
     */
    style_italic: boolean;
    /**
     * @generated from protobuf field: bool style_light = 8 [json_name = "style_light"];
     */
    style_light: boolean;
    /**
     * @generated from protobuf field: string usage = 9;
     */
    usage: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelFontEnabled
 */
export interface ImageKernelFontEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.ImageKernelFont fonts = 2;
     */
    fonts: ImageKernelFont[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelLookandFeelRule
 */
export interface ImageKernelLookandFeelRule {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string; // md5 of the rule
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: string rule = 3;
     */
    rule: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelLookandFeelEnabled
 */
export interface ImageKernelLookandFeelEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.ImageKernelLookandFeelRule rules = 2;
     */
    rules: ImageKernelLookandFeelRule[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelProductDetection
 */
export interface ImageKernelProductDetection {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.ImageKernelSetting
 */
export interface ImageKernelSetting {
    /**
     * @generated from protobuf field: string id = 1 [json_name = "kernel_id"];
     */
    id: string;
    /**
     * @generated from protobuf field: int32 threshold = 2;
     */
    threshold: number;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelScoringEnabled brand_voice = 3 [json_name = "brand_voice"];
     */
    brand_voice?: ImageKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelScoringEnabled sexually_explicit = 4 [json_name = "sexually_explicit"];
     */
    sexually_explicit?: ImageKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelScoringEnabled image_quality_general = 5 [json_name = "quality_general"];
     */
    image_quality_general?: ImageKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelScoringEnabled image_violence = 6 [json_name = "image_violence"];
     */
    image_violence?: ImageKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelLogosEnabled image_logo_detection = 7 [json_name = "image_logo_detection"];
     */
    image_logo_detection?: ImageKernelLogosEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelLookandFeelEnabled image_lookandfeel = 8 [json_name = "image_lookandfeel"];
     */
    image_lookandfeel?: ImageKernelLookandFeelEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelFontEnabled image_font_detection = 9 [json_name = "image_font_detection"];
     */
    image_font_detection?: ImageKernelFontEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelBackgroundColorEnabled image_background_colors = 10 [json_name = "image_background_colors"];
     */
    image_background_colors?: ImageKernelBackgroundColorEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelScoringEnabled brand_consistency = 11 [json_name = "brand_consistency"];
     */
    brand_consistency?: ImageKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelScoringEnabled image_onbrand = 12 [json_name = "image_onbrand"];
     */
    image_onbrand?: ImageKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelProductDetection product_detection = 13 [json_name = "product_detection"];
     */
    product_detection?: ImageKernelProductDetection;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelScoringEnabled ai_generated = 14 [json_name = "ai_generated"];
     */
    ai_generated?: ImageKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageKernelScoringToneAndVoice copy_tone_and_voice = 15 [json_name = "copy_tone_and_voice"];
     */
    copy_tone_and_voice?: ImageKernelScoringToneAndVoice;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelScoringEnabled
 */
export interface DocumentKernelScoringEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelLookandFeelRule
 */
export interface DocumentKernelLookandFeelRule {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string; // md5 of the rule
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: string rule = 3;
     */
    rule: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelLookandFeelEnabled
 */
export interface DocumentKernelLookandFeelEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.DocumentKernelLookandFeelRule rules = 2;
     */
    rules: DocumentKernelLookandFeelRule[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelLogo
 */
export interface DocumentKernelLogo {
    /**
     * @generated from protobuf field: string mimetype = 1;
     */
    mimetype: string;
    /**
     * @generated from protobuf field: string md5 = 2;
     */
    md5: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string image = 4;
     */
    image: string;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageClearspace clearspace = 5;
     */
    clearspace?: ImageClearspace;
    /**
     * @generated from protobuf field: string usage = 6;
     */
    usage: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelLogosEnabled
 */
export interface DocumentKernelLogosEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.DocumentKernelLogo logos = 2;
     */
    logos: DocumentKernelLogo[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelFont
 */
export interface DocumentKernelFont {
    /**
     * @generated from protobuf field: string md5 = 1;
     */
    md5: string;
    /**
     * @generated from protobuf field: string mimetype = 2;
     */
    mimetype: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string font = 4;
     */
    font: string;
    /**
     * @generated from protobuf field: bool style_regular = 5 [json_name = "style_regular"];
     */
    style_regular: boolean;
    /**
     * @generated from protobuf field: bool style_bold = 6 [json_name = "style_bold"];
     */
    style_bold: boolean;
    /**
     * @generated from protobuf field: bool style_italic = 7 [json_name = "style_italic"];
     */
    style_italic: boolean;
    /**
     * @generated from protobuf field: bool style_light = 8 [json_name = "style_light"];
     */
    style_light: boolean;
    /**
     * @generated from protobuf field: string usage = 9;
     */
    usage: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelFontEnabled
 */
export interface DocumentKernelFontEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.DocumentKernelFont fonts = 2;
     */
    fonts: DocumentKernelFont[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelBackgroundColor
 */
export interface DocumentKernelBackgroundColor {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string color = 2;
     */
    color: string; // hexadecimal string representing color
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string usage = 4;
     */
    usage: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelBackgroundColorEnabled
 */
export interface DocumentKernelBackgroundColorEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.DocumentKernelBackgroundColor colors = 2;
     */
    colors: DocumentKernelBackgroundColor[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelRule
 */
export interface DocumentKernelRule {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: string rule = 3;
     */
    rule: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelRulesEnabled
 */
export interface DocumentKernelRulesEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.DocumentKernelRule rules = 2;
     */
    rules: DocumentKernelRule[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelProductDetection
 */
export interface DocumentKernelProductDetection {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.DocumentKernelSetting
 */
export interface DocumentKernelSetting {
    /**
     * @generated from protobuf field: string id = 1 [json_name = "kernel_id"];
     */
    id: string;
    /**
     * @generated from protobuf field: int32 threshold = 2;
     */
    threshold: number;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelScoringEnabled doc_brand_voice = 3 [json_name = "doc_brand_voice"];
     */
    doc_brand_voice?: DocumentKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelScoringEnabled doc_nudity = 4 [json_name = "doc_nudity"];
     */
    doc_nudity?: DocumentKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelScoringEnabled doc_violence = 5 [json_name = "doc_violence"];
     */
    doc_violence?: DocumentKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelScoringEnabled doc_racism = 6 [json_name = "doc_racism"];
     */
    doc_racism?: DocumentKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelScoringEnabled doc_grammar = 7 [json_name = "doc_grammar"];
     */
    doc_grammar?: DocumentKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelLookandFeelEnabled doc_lookandfeel = 8 [json_name = "doc_lookandfeel"];
     */
    doc_lookandfeel?: DocumentKernelLookandFeelEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelLogosEnabled doc_logo_detection = 9 [json_name = "doc_logo_detection"];
     */
    doc_logo_detection?: DocumentKernelLogosEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelFontEnabled doc_font_detection = 10 [json_name = "doc_font_detection"];
     */
    doc_font_detection?: DocumentKernelFontEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelRulesEnabled doc_rules = 11 [json_name = "doc_rules"];
     */
    doc_rules?: DocumentKernelRulesEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelScoringEnabled brand_consistency = 12 [json_name = "brand_consistency"];
     */
    brand_consistency?: DocumentKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelProductDetection product_detection = 13 [json_name = "product_detection"];
     */
    product_detection?: DocumentKernelProductDetection;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelScoringEnabled ai_generated = 14 [json_name = "ai_generated"];
     */
    ai_generated?: DocumentKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelBackgroundColorEnabled doc_background_colors = 15 [json_name = "doc_background_colors"];
     */
    doc_background_colors?: DocumentKernelBackgroundColorEnabled;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelScoringEnabled
 */
export interface VideoKernelScoringEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelLogo
 */
export interface VideoKernelLogo {
    /**
     * @generated from protobuf field: string mimetype = 1;
     */
    mimetype: string;
    /**
     * @generated from protobuf field: string md5 = 2;
     */
    md5: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string image = 4;
     */
    image: string;
    /**
     * @generated from protobuf field: brandguard.kernel.ImageClearspace clearspace = 5;
     */
    clearspace?: ImageClearspace;
    /**
     * @generated from protobuf field: string usage = 6;
     */
    usage: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelLogosEnabled
 */
export interface VideoKernelLogosEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.VideoKernelLogo logos = 2;
     */
    logos: VideoKernelLogo[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelFont
 */
export interface VideoKernelFont {
    /**
     * @generated from protobuf field: string md5 = 1;
     */
    md5: string;
    /**
     * @generated from protobuf field: string mimetype = 2;
     */
    mimetype: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string font = 4;
     */
    font: string;
    /**
     * @generated from protobuf field: bool style_regular = 5 [json_name = "style_regular"];
     */
    style_regular: boolean;
    /**
     * @generated from protobuf field: bool style_bold = 6 [json_name = "style_bold"];
     */
    style_bold: boolean;
    /**
     * @generated from protobuf field: bool style_italic = 7 [json_name = "style_italic"];
     */
    style_italic: boolean;
    /**
     * @generated from protobuf field: bool style_light = 8 [json_name = "style_light"];
     */
    style_light: boolean;
    /**
     * @generated from protobuf field: string usage = 9;
     */
    usage: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelFontEnabled
 */
export interface VideoKernelFontEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.VideoKernelFont fonts = 2;
     */
    fonts: VideoKernelFont[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelBackgroundColor
 */
export interface VideoKernelBackgroundColor {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string color = 2;
     */
    color: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string usage = 4;
     */
    usage: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelBackgroundColorEnabled
 */
export interface VideoKernelBackgroundColorEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.VideoKernelBackgroundColor colors = 2;
     */
    colors: VideoKernelBackgroundColor[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelLookandFeelRule
 */
export interface VideoKernelLookandFeelRule {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: string rule = 3;
     */
    rule: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelLookandFeelEnabled
 */
export interface VideoKernelLookandFeelEnabled {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated brandguard.kernel.VideoKernelLookandFeelRule rules = 2;
     */
    rules: VideoKernelLookandFeelRule[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelProductDetection
 */
export interface VideoKernelProductDetection {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.kernel.VideoKernelSetting
 */
export interface VideoKernelSetting {
    /**
     * @generated from protobuf field: string id = 1 [json_name = "kernel_id"];
     */
    id: string;
    /**
     * @generated from protobuf field: int32 threshold = 2;
     */
    threshold: number;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelScoringEnabled brand_voice = 3 [json_name = "brand_voice"];
     */
    brand_voice?: VideoKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelScoringEnabled sexually_explicit = 4 [json_name = "sexually_explicit"];
     */
    sexually_explicit?: VideoKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelScoringEnabled video_quality_general = 5 [json_name = "quality_general"];
     */
    video_quality_general?: VideoKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelScoringEnabled video_violence = 6 [json_name = "video_violence"];
     */
    video_violence?: VideoKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelLogosEnabled video_logo_detection = 7 [json_name = "video_logo_detection"];
     */
    video_logo_detection?: VideoKernelLogosEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelLookandFeelEnabled video_lookandfeel = 8 [json_name = "video_lookandfeel"];
     */
    video_lookandfeel?: VideoKernelLookandFeelEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelFontEnabled video_font_detection = 9 [json_name = "video_font_detection"];
     */
    video_font_detection?: VideoKernelFontEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelBackgroundColorEnabled video_background_colors = 10 [json_name = "video_background_colors"];
     */
    video_background_colors?: VideoKernelBackgroundColorEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelScoringEnabled brand_consistency = 11 [json_name = "brand_consistency"];
     */
    brand_consistency?: VideoKernelScoringEnabled;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelProductDetection product_detection = 12 [json_name = "product_detection"];
     */
    product_detection?: VideoKernelProductDetection;
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelScoringEnabled ai_generated = 13 [json_name = "ai_generated"];
     */
    ai_generated?: VideoKernelScoringEnabled;
}
/**
 * @generated from protobuf enum brandguard.kernel.Status
 */
export enum Status {
    /**
     * @generated from protobuf enum value: PENDING = 0;
     */
    PENDING = 0,
    /**
     * @generated from protobuf enum value: COMPILED = 1;
     */
    COMPILED = 1,
    /**
     * @generated from protobuf enum value: VALIDATED = 2;
     */
    VALIDATED = 2,
    /**
     * @generated from protobuf enum value: READY = 3;
     */
    READY = 3,
    /**
     * @generated from protobuf enum value: Error = 1000;
     */
    Error = 1000,
    /**
     * @generated from protobuf enum value: CompilationError = 1001;
     */
    CompilationError = 1001
}
/**
 * @generated from protobuf enum brandguard.kernel.GrammarProvider
 */
export enum GrammarProvider {
    /**
     * @generated from protobuf enum value: GRAMMAR_PROVIDER_GPT4O_MINI = 0;
     */
    GPT4O_MINI = 0,
    /**
     * @generated from protobuf enum value: GRAMMAR_PROVIDER_GEMINI = 1;
     */
    GEMINI = 1
}
/**
 * @generated from protobuf enum brandguard.kernel.ProfanityProvider
 */
export enum ProfanityProvider {
    /**
     * @generated from protobuf enum value: PROFANITY_PROVIDER_GPT4O_MINI = 0;
     */
    GPT4O_MINI = 0,
    /**
     * @generated from protobuf enum value: PROFANITY_PROVIDER_GEMINI = 1;
     */
    GEMINI = 1
}
/**
 * @generated from protobuf enum brandguard.kernel.RacismProvider
 */
export enum RacismProvider {
    /**
     * @generated from protobuf enum value: RACISM_PROVIDER_GPT4O_MINI = 0;
     */
    GPT4O_MINI = 0,
    /**
     * @generated from protobuf enum value: RACISM_PROVIDER_GEMINI = 1;
     */
    GEMINI = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class KernelMetadata$Type extends MessageType<KernelMetadata> {
    constructor() {
        super("brandguard.kernel.KernelMetadata", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "account_id", kind: "scalar", localName: "account_id", jsonName: "account_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "mimetype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", localName: "created_at", jsonName: "created_at", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "updated_at", kind: "scalar", localName: "updated_at", jsonName: "updated_at", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "status", kind: "enum", T: () => ["brandguard.kernel.Status", Status] },
            { no: 11, name: "settings_md5", kind: "scalar", localName: "settings_md5", jsonName: "settings_md5", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<KernelMetadata>): KernelMetadata {
        const message = { id: "", version: "", account_id: "", brand_id: "", name: "", mimetype: "", created_at: "", updated_at: "", status: 0, settings_md5: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<KernelMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KernelMetadata): KernelMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string version */ 2:
                    message.version = reader.string();
                    break;
                case /* string account_id = 3 [json_name = "account_id"];*/ 3:
                    message.account_id = reader.string();
                    break;
                case /* string brand_id = 4 [json_name = "brand_id"];*/ 4:
                    message.brand_id = reader.string();
                    break;
                case /* string name */ 6:
                    message.name = reader.string();
                    break;
                case /* string mimetype */ 5:
                    message.mimetype = reader.string();
                    break;
                case /* string created_at = 8 [json_name = "created_at"];*/ 8:
                    message.created_at = reader.string();
                    break;
                case /* string updated_at = 9 [json_name = "updated_at"];*/ 9:
                    message.updated_at = reader.string();
                    break;
                case /* brandguard.kernel.Status status */ 10:
                    message.status = reader.int32();
                    break;
                case /* string settings_md5 = 11 [json_name = "settings_md5"];*/ 11:
                    message.settings_md5 = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KernelMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string version = 2; */
        if (message.version !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.version);
        /* string account_id = 3 [json_name = "account_id"]; */
        if (message.account_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.account_id);
        /* string brand_id = 4 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.brand_id);
        /* string name = 6; */
        if (message.name !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.name);
        /* string mimetype = 5; */
        if (message.mimetype !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.mimetype);
        /* string created_at = 8 [json_name = "created_at"]; */
        if (message.created_at !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.created_at);
        /* string updated_at = 9 [json_name = "updated_at"]; */
        if (message.updated_at !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.updated_at);
        /* brandguard.kernel.Status status = 10; */
        if (message.status !== 0)
            writer.tag(10, WireType.Varint).int32(message.status);
        /* string settings_md5 = 11 [json_name = "settings_md5"]; */
        if (message.settings_md5 !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.settings_md5);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.KernelMetadata
 */
export const KernelMetadata = new KernelMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KernelNameUpdateRequest$Type extends MessageType<KernelNameUpdateRequest> {
    constructor() {
        super("brandguard.kernel.KernelNameUpdateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<KernelNameUpdateRequest>): KernelNameUpdateRequest {
        const message = { id: "", name: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<KernelNameUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KernelNameUpdateRequest): KernelNameUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KernelNameUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.KernelNameUpdateRequest
 */
export const KernelNameUpdateRequest = new KernelNameUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KernelNameUpdateResponse$Type extends MessageType<KernelNameUpdateResponse> {
    constructor() {
        super("brandguard.kernel.KernelNameUpdateResponse", [
            { no: 1, name: "kernel", kind: "message", T: () => KernelMetadata }
        ]);
    }
    create(value?: PartialMessage<KernelNameUpdateResponse>): KernelNameUpdateResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<KernelNameUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KernelNameUpdateResponse): KernelNameUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.kernel.KernelMetadata kernel */ 1:
                    message.kernel = KernelMetadata.internalBinaryRead(reader, reader.uint32(), options, message.kernel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KernelNameUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.kernel.KernelMetadata kernel = 1; */
        if (message.kernel)
            KernelMetadata.internalBinaryWrite(message.kernel, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.KernelNameUpdateResponse
 */
export const KernelNameUpdateResponse = new KernelNameUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextKernelScoringEnabled$Type extends MessageType<TextKernelScoringEnabled> {
    constructor() {
        super("brandguard.kernel.TextKernelScoringEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TextKernelScoringEnabled>): TextKernelScoringEnabled {
        const message = { enabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TextKernelScoringEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextKernelScoringEnabled): TextKernelScoringEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextKernelScoringEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.TextKernelScoringEnabled
 */
export const TextKernelScoringEnabled = new TextKernelScoringEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextKernelScoringToneAndVoice$Type extends MessageType<TextKernelScoringToneAndVoice> {
    constructor() {
        super("brandguard.kernel.TextKernelScoringToneAndVoice", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TextKernelScoringToneAndVoice>): TextKernelScoringToneAndVoice {
        const message = { enabled: false, prompt: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TextKernelScoringToneAndVoice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextKernelScoringToneAndVoice): TextKernelScoringToneAndVoice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* string prompt */ 2:
                    message.prompt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextKernelScoringToneAndVoice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* string prompt = 2; */
        if (message.prompt !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.prompt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.TextKernelScoringToneAndVoice
 */
export const TextKernelScoringToneAndVoice = new TextKernelScoringToneAndVoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextKernelScoringGrammar$Type extends MessageType<TextKernelScoringGrammar> {
    constructor() {
        super("brandguard.kernel.TextKernelScoringGrammar", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "provider", kind: "enum", T: () => ["brandguard.kernel.GrammarProvider", GrammarProvider, "GRAMMAR_PROVIDER_"] }
        ]);
    }
    create(value?: PartialMessage<TextKernelScoringGrammar>): TextKernelScoringGrammar {
        const message = { enabled: false, provider: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TextKernelScoringGrammar>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextKernelScoringGrammar): TextKernelScoringGrammar {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* brandguard.kernel.GrammarProvider provider */ 2:
                    message.provider = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextKernelScoringGrammar, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* brandguard.kernel.GrammarProvider provider = 2; */
        if (message.provider !== 0)
            writer.tag(2, WireType.Varint).int32(message.provider);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.TextKernelScoringGrammar
 */
export const TextKernelScoringGrammar = new TextKernelScoringGrammar$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextKernelScoringProfanity$Type extends MessageType<TextKernelScoringProfanity> {
    constructor() {
        super("brandguard.kernel.TextKernelScoringProfanity", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "provider", kind: "enum", T: () => ["brandguard.kernel.ProfanityProvider", ProfanityProvider, "PROFANITY_PROVIDER_"] }
        ]);
    }
    create(value?: PartialMessage<TextKernelScoringProfanity>): TextKernelScoringProfanity {
        const message = { enabled: false, provider: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TextKernelScoringProfanity>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextKernelScoringProfanity): TextKernelScoringProfanity {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* brandguard.kernel.ProfanityProvider provider */ 2:
                    message.provider = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextKernelScoringProfanity, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* brandguard.kernel.ProfanityProvider provider = 2; */
        if (message.provider !== 0)
            writer.tag(2, WireType.Varint).int32(message.provider);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.TextKernelScoringProfanity
 */
export const TextKernelScoringProfanity = new TextKernelScoringProfanity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextKernelScoringRacism$Type extends MessageType<TextKernelScoringRacism> {
    constructor() {
        super("brandguard.kernel.TextKernelScoringRacism", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "provider", kind: "enum", T: () => ["brandguard.kernel.RacismProvider", RacismProvider, "RACISM_PROVIDER_"] }
        ]);
    }
    create(value?: PartialMessage<TextKernelScoringRacism>): TextKernelScoringRacism {
        const message = { enabled: false, provider: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TextKernelScoringRacism>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextKernelScoringRacism): TextKernelScoringRacism {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* brandguard.kernel.RacismProvider provider */ 2:
                    message.provider = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextKernelScoringRacism, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* brandguard.kernel.RacismProvider provider = 2; */
        if (message.provider !== 0)
            writer.tag(2, WireType.Varint).int32(message.provider);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.TextKernelScoringRacism
 */
export const TextKernelScoringRacism = new TextKernelScoringRacism$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextKernelReferenceRule$Type extends MessageType<TextKernelReferenceRule> {
    constructor() {
        super("brandguard.kernel.TextKernelReferenceRule", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rule", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TextKernelReferenceRule>): TextKernelReferenceRule {
        const message = { id: "", description: "", rule: "", explanation: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TextKernelReferenceRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextKernelReferenceRule): TextKernelReferenceRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string rule */ 3:
                    message.rule = reader.string();
                    break;
                case /* string explanation */ 4:
                    message.explanation = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextKernelReferenceRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string rule = 3; */
        if (message.rule !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rule);
        /* string explanation = 4; */
        if (message.explanation !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.explanation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.TextKernelReferenceRule
 */
export const TextKernelReferenceRule = new TextKernelReferenceRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextKernelReferenceRulesEnabled$Type extends MessageType<TextKernelReferenceRulesEnabled> {
    constructor() {
        super("brandguard.kernel.TextKernelReferenceRulesEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "rules", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TextKernelReferenceRule }
        ]);
    }
    create(value?: PartialMessage<TextKernelReferenceRulesEnabled>): TextKernelReferenceRulesEnabled {
        const message = { enabled: false, rules: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TextKernelReferenceRulesEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextKernelReferenceRulesEnabled): TextKernelReferenceRulesEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.TextKernelReferenceRule rules */ 2:
                    message.rules.push(TextKernelReferenceRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextKernelReferenceRulesEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.TextKernelReferenceRule rules = 2; */
        for (let i = 0; i < message.rules.length; i++)
            TextKernelReferenceRule.internalBinaryWrite(message.rules[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.TextKernelReferenceRulesEnabled
 */
export const TextKernelReferenceRulesEnabled = new TextKernelReferenceRulesEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextKernelProductDetection$Type extends MessageType<TextKernelProductDetection> {
    constructor() {
        super("brandguard.kernel.TextKernelProductDetection", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TextKernelProductDetection>): TextKernelProductDetection {
        const message = { enabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TextKernelProductDetection>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextKernelProductDetection): TextKernelProductDetection {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextKernelProductDetection, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.TextKernelProductDetection
 */
export const TextKernelProductDetection = new TextKernelProductDetection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextKernelSetting$Type extends MessageType<TextKernelSetting> {
    constructor() {
        super("brandguard.kernel.TextKernelSetting", [
            { no: 1, name: "id", kind: "scalar", jsonName: "kernel_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "threshold", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "brand_voice", kind: "message", localName: "brand_voice", jsonName: "brand_voice", T: () => TextKernelScoringEnabled },
            { no: 4, name: "profanity", kind: "message", T: () => TextKernelScoringProfanity },
            { no: 5, name: "racism", kind: "message", T: () => TextKernelScoringRacism },
            { no: 6, name: "tnv", kind: "message", T: () => TextKernelScoringToneAndVoice },
            { no: 7, name: "emotions", kind: "message", T: () => TextKernelScoringEnabled },
            { no: 8, name: "grammar", kind: "message", T: () => TextKernelScoringGrammar },
            { no: 9, name: "reference_rules", kind: "message", localName: "reference_rules", jsonName: "reference_rules", T: () => TextKernelReferenceRulesEnabled },
            { no: 10, name: "brand_consistency", kind: "message", localName: "brand_consistency", jsonName: "brand_consistency", T: () => TextKernelScoringEnabled },
            { no: 11, name: "product_detection", kind: "message", localName: "product_detection", jsonName: "product_detection", T: () => TextKernelProductDetection },
            { no: 12, name: "ai_generated", kind: "message", localName: "ai_generated", jsonName: "ai_generated", T: () => TextKernelScoringEnabled }
        ]);
    }
    create(value?: PartialMessage<TextKernelSetting>): TextKernelSetting {
        const message = { id: "", threshold: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TextKernelSetting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextKernelSetting): TextKernelSetting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id = 1 [json_name = "kernel_id"];*/ 1:
                    message.id = reader.string();
                    break;
                case /* int32 threshold */ 2:
                    message.threshold = reader.int32();
                    break;
                case /* brandguard.kernel.TextKernelScoringEnabled brand_voice = 3 [json_name = "brand_voice"];*/ 3:
                    message.brand_voice = TextKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.brand_voice);
                    break;
                case /* brandguard.kernel.TextKernelScoringProfanity profanity */ 4:
                    message.profanity = TextKernelScoringProfanity.internalBinaryRead(reader, reader.uint32(), options, message.profanity);
                    break;
                case /* brandguard.kernel.TextKernelScoringRacism racism */ 5:
                    message.racism = TextKernelScoringRacism.internalBinaryRead(reader, reader.uint32(), options, message.racism);
                    break;
                case /* brandguard.kernel.TextKernelScoringToneAndVoice tnv */ 6:
                    message.tnv = TextKernelScoringToneAndVoice.internalBinaryRead(reader, reader.uint32(), options, message.tnv);
                    break;
                case /* brandguard.kernel.TextKernelScoringEnabled emotions */ 7:
                    message.emotions = TextKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.emotions);
                    break;
                case /* brandguard.kernel.TextKernelScoringGrammar grammar */ 8:
                    message.grammar = TextKernelScoringGrammar.internalBinaryRead(reader, reader.uint32(), options, message.grammar);
                    break;
                case /* brandguard.kernel.TextKernelReferenceRulesEnabled reference_rules = 9 [json_name = "reference_rules"];*/ 9:
                    message.reference_rules = TextKernelReferenceRulesEnabled.internalBinaryRead(reader, reader.uint32(), options, message.reference_rules);
                    break;
                case /* brandguard.kernel.TextKernelScoringEnabled brand_consistency = 10 [json_name = "brand_consistency"];*/ 10:
                    message.brand_consistency = TextKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.brand_consistency);
                    break;
                case /* brandguard.kernel.TextKernelProductDetection product_detection = 11 [json_name = "product_detection"];*/ 11:
                    message.product_detection = TextKernelProductDetection.internalBinaryRead(reader, reader.uint32(), options, message.product_detection);
                    break;
                case /* brandguard.kernel.TextKernelScoringEnabled ai_generated = 12 [json_name = "ai_generated"];*/ 12:
                    message.ai_generated = TextKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.ai_generated);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextKernelSetting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1 [json_name = "kernel_id"]; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* int32 threshold = 2; */
        if (message.threshold !== 0)
            writer.tag(2, WireType.Varint).int32(message.threshold);
        /* brandguard.kernel.TextKernelScoringEnabled brand_voice = 3 [json_name = "brand_voice"]; */
        if (message.brand_voice)
            TextKernelScoringEnabled.internalBinaryWrite(message.brand_voice, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.TextKernelScoringProfanity profanity = 4; */
        if (message.profanity)
            TextKernelScoringProfanity.internalBinaryWrite(message.profanity, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.TextKernelScoringRacism racism = 5; */
        if (message.racism)
            TextKernelScoringRacism.internalBinaryWrite(message.racism, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.TextKernelScoringToneAndVoice tnv = 6; */
        if (message.tnv)
            TextKernelScoringToneAndVoice.internalBinaryWrite(message.tnv, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.TextKernelScoringEnabled emotions = 7; */
        if (message.emotions)
            TextKernelScoringEnabled.internalBinaryWrite(message.emotions, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.TextKernelScoringGrammar grammar = 8; */
        if (message.grammar)
            TextKernelScoringGrammar.internalBinaryWrite(message.grammar, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.TextKernelReferenceRulesEnabled reference_rules = 9 [json_name = "reference_rules"]; */
        if (message.reference_rules)
            TextKernelReferenceRulesEnabled.internalBinaryWrite(message.reference_rules, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.TextKernelScoringEnabled brand_consistency = 10 [json_name = "brand_consistency"]; */
        if (message.brand_consistency)
            TextKernelScoringEnabled.internalBinaryWrite(message.brand_consistency, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.TextKernelProductDetection product_detection = 11 [json_name = "product_detection"]; */
        if (message.product_detection)
            TextKernelProductDetection.internalBinaryWrite(message.product_detection, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.TextKernelScoringEnabled ai_generated = 12 [json_name = "ai_generated"]; */
        if (message.ai_generated)
            TextKernelScoringEnabled.internalBinaryWrite(message.ai_generated, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.TextKernelSetting
 */
export const TextKernelSetting = new TextKernelSetting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelScoringEnabled$Type extends MessageType<ImageKernelScoringEnabled> {
    constructor() {
        super("brandguard.kernel.ImageKernelScoringEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ImageKernelScoringEnabled>): ImageKernelScoringEnabled {
        const message = { enabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelScoringEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelScoringEnabled): ImageKernelScoringEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelScoringEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelScoringEnabled
 */
export const ImageKernelScoringEnabled = new ImageKernelScoringEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelScoringToneAndVoice$Type extends MessageType<ImageKernelScoringToneAndVoice> {
    constructor() {
        super("brandguard.kernel.ImageKernelScoringToneAndVoice", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ImageKernelScoringToneAndVoice>): ImageKernelScoringToneAndVoice {
        const message = { enabled: false, prompt: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelScoringToneAndVoice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelScoringToneAndVoice): ImageKernelScoringToneAndVoice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* string prompt */ 2:
                    message.prompt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelScoringToneAndVoice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* string prompt = 2; */
        if (message.prompt !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.prompt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelScoringToneAndVoice
 */
export const ImageKernelScoringToneAndVoice = new ImageKernelScoringToneAndVoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageClearspace$Type extends MessageType<ImageClearspace> {
    constructor() {
        super("brandguard.kernel.ImageClearspace", [
            { no: 1, name: "horizontal", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "vertical", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<ImageClearspace>): ImageClearspace {
        const message = { horizontal: 0, vertical: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageClearspace>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageClearspace): ImageClearspace {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double horizontal */ 1:
                    message.horizontal = reader.double();
                    break;
                case /* double vertical */ 2:
                    message.vertical = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageClearspace, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double horizontal = 1; */
        if (message.horizontal !== 0)
            writer.tag(1, WireType.Bit64).double(message.horizontal);
        /* double vertical = 2; */
        if (message.vertical !== 0)
            writer.tag(2, WireType.Bit64).double(message.vertical);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageClearspace
 */
export const ImageClearspace = new ImageClearspace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelLogo$Type extends MessageType<ImageKernelLogo> {
    constructor() {
        super("brandguard.kernel.ImageKernelLogo", [
            { no: 1, name: "mimetype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "md5", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "image", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "clearspace", kind: "message", T: () => ImageClearspace },
            { no: 6, name: "usage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ImageKernelLogo>): ImageKernelLogo {
        const message = { mimetype: "", md5: "", description: "", image: "", usage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelLogo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelLogo): ImageKernelLogo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string mimetype */ 1:
                    message.mimetype = reader.string();
                    break;
                case /* string md5 */ 2:
                    message.md5 = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string image */ 4:
                    message.image = reader.string();
                    break;
                case /* brandguard.kernel.ImageClearspace clearspace */ 5:
                    message.clearspace = ImageClearspace.internalBinaryRead(reader, reader.uint32(), options, message.clearspace);
                    break;
                case /* string usage */ 6:
                    message.usage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelLogo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string mimetype = 1; */
        if (message.mimetype !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.mimetype);
        /* string md5 = 2; */
        if (message.md5 !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.md5);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string image = 4; */
        if (message.image !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.image);
        /* brandguard.kernel.ImageClearspace clearspace = 5; */
        if (message.clearspace)
            ImageClearspace.internalBinaryWrite(message.clearspace, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string usage = 6; */
        if (message.usage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelLogo
 */
export const ImageKernelLogo = new ImageKernelLogo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelLogosEnabled$Type extends MessageType<ImageKernelLogosEnabled> {
    constructor() {
        super("brandguard.kernel.ImageKernelLogosEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "logos", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ImageKernelLogo }
        ]);
    }
    create(value?: PartialMessage<ImageKernelLogosEnabled>): ImageKernelLogosEnabled {
        const message = { enabled: false, logos: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelLogosEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelLogosEnabled): ImageKernelLogosEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.ImageKernelLogo logos */ 2:
                    message.logos.push(ImageKernelLogo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelLogosEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.ImageKernelLogo logos = 2; */
        for (let i = 0; i < message.logos.length; i++)
            ImageKernelLogo.internalBinaryWrite(message.logos[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelLogosEnabled
 */
export const ImageKernelLogosEnabled = new ImageKernelLogosEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelBackgroundColor$Type extends MessageType<ImageKernelBackgroundColor> {
    constructor() {
        super("brandguard.kernel.ImageKernelBackgroundColor", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "usage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ImageKernelBackgroundColor>): ImageKernelBackgroundColor {
        const message = { id: "", color: "", description: "", usage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelBackgroundColor>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelBackgroundColor): ImageKernelBackgroundColor {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string color */ 2:
                    message.color = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string usage */ 4:
                    message.usage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelBackgroundColor, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string color = 2; */
        if (message.color !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.color);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string usage = 4; */
        if (message.usage !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelBackgroundColor
 */
export const ImageKernelBackgroundColor = new ImageKernelBackgroundColor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelBackgroundColorEnabled$Type extends MessageType<ImageKernelBackgroundColorEnabled> {
    constructor() {
        super("brandguard.kernel.ImageKernelBackgroundColorEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "colors", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ImageKernelBackgroundColor }
        ]);
    }
    create(value?: PartialMessage<ImageKernelBackgroundColorEnabled>): ImageKernelBackgroundColorEnabled {
        const message = { enabled: false, colors: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelBackgroundColorEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelBackgroundColorEnabled): ImageKernelBackgroundColorEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.ImageKernelBackgroundColor colors */ 2:
                    message.colors.push(ImageKernelBackgroundColor.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelBackgroundColorEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.ImageKernelBackgroundColor colors = 2; */
        for (let i = 0; i < message.colors.length; i++)
            ImageKernelBackgroundColor.internalBinaryWrite(message.colors[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelBackgroundColorEnabled
 */
export const ImageKernelBackgroundColorEnabled = new ImageKernelBackgroundColorEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelFont$Type extends MessageType<ImageKernelFont> {
    constructor() {
        super("brandguard.kernel.ImageKernelFont", [
            { no: 1, name: "md5", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mimetype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "font", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "style_regular", kind: "scalar", localName: "style_regular", jsonName: "style_regular", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "style_bold", kind: "scalar", localName: "style_bold", jsonName: "style_bold", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "style_italic", kind: "scalar", localName: "style_italic", jsonName: "style_italic", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "style_light", kind: "scalar", localName: "style_light", jsonName: "style_light", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "usage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ImageKernelFont>): ImageKernelFont {
        const message = { md5: "", mimetype: "", description: "", font: "", style_regular: false, style_bold: false, style_italic: false, style_light: false, usage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelFont>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelFont): ImageKernelFont {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string md5 */ 1:
                    message.md5 = reader.string();
                    break;
                case /* string mimetype */ 2:
                    message.mimetype = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string font */ 4:
                    message.font = reader.string();
                    break;
                case /* bool style_regular = 5 [json_name = "style_regular"];*/ 5:
                    message.style_regular = reader.bool();
                    break;
                case /* bool style_bold = 6 [json_name = "style_bold"];*/ 6:
                    message.style_bold = reader.bool();
                    break;
                case /* bool style_italic = 7 [json_name = "style_italic"];*/ 7:
                    message.style_italic = reader.bool();
                    break;
                case /* bool style_light = 8 [json_name = "style_light"];*/ 8:
                    message.style_light = reader.bool();
                    break;
                case /* string usage */ 9:
                    message.usage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelFont, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string md5 = 1; */
        if (message.md5 !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.md5);
        /* string mimetype = 2; */
        if (message.mimetype !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mimetype);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string font = 4; */
        if (message.font !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.font);
        /* bool style_regular = 5 [json_name = "style_regular"]; */
        if (message.style_regular !== false)
            writer.tag(5, WireType.Varint).bool(message.style_regular);
        /* bool style_bold = 6 [json_name = "style_bold"]; */
        if (message.style_bold !== false)
            writer.tag(6, WireType.Varint).bool(message.style_bold);
        /* bool style_italic = 7 [json_name = "style_italic"]; */
        if (message.style_italic !== false)
            writer.tag(7, WireType.Varint).bool(message.style_italic);
        /* bool style_light = 8 [json_name = "style_light"]; */
        if (message.style_light !== false)
            writer.tag(8, WireType.Varint).bool(message.style_light);
        /* string usage = 9; */
        if (message.usage !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelFont
 */
export const ImageKernelFont = new ImageKernelFont$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelFontEnabled$Type extends MessageType<ImageKernelFontEnabled> {
    constructor() {
        super("brandguard.kernel.ImageKernelFontEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "fonts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ImageKernelFont }
        ]);
    }
    create(value?: PartialMessage<ImageKernelFontEnabled>): ImageKernelFontEnabled {
        const message = { enabled: false, fonts: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelFontEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelFontEnabled): ImageKernelFontEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.ImageKernelFont fonts */ 2:
                    message.fonts.push(ImageKernelFont.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelFontEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.ImageKernelFont fonts = 2; */
        for (let i = 0; i < message.fonts.length; i++)
            ImageKernelFont.internalBinaryWrite(message.fonts[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelFontEnabled
 */
export const ImageKernelFontEnabled = new ImageKernelFontEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelLookandFeelRule$Type extends MessageType<ImageKernelLookandFeelRule> {
    constructor() {
        super("brandguard.kernel.ImageKernelLookandFeelRule", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rule", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ImageKernelLookandFeelRule>): ImageKernelLookandFeelRule {
        const message = { id: "", description: "", rule: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelLookandFeelRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelLookandFeelRule): ImageKernelLookandFeelRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string rule */ 3:
                    message.rule = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelLookandFeelRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string rule = 3; */
        if (message.rule !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rule);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelLookandFeelRule
 */
export const ImageKernelLookandFeelRule = new ImageKernelLookandFeelRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelLookandFeelEnabled$Type extends MessageType<ImageKernelLookandFeelEnabled> {
    constructor() {
        super("brandguard.kernel.ImageKernelLookandFeelEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "rules", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ImageKernelLookandFeelRule }
        ]);
    }
    create(value?: PartialMessage<ImageKernelLookandFeelEnabled>): ImageKernelLookandFeelEnabled {
        const message = { enabled: false, rules: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelLookandFeelEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelLookandFeelEnabled): ImageKernelLookandFeelEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.ImageKernelLookandFeelRule rules */ 2:
                    message.rules.push(ImageKernelLookandFeelRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelLookandFeelEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.ImageKernelLookandFeelRule rules = 2; */
        for (let i = 0; i < message.rules.length; i++)
            ImageKernelLookandFeelRule.internalBinaryWrite(message.rules[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelLookandFeelEnabled
 */
export const ImageKernelLookandFeelEnabled = new ImageKernelLookandFeelEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelProductDetection$Type extends MessageType<ImageKernelProductDetection> {
    constructor() {
        super("brandguard.kernel.ImageKernelProductDetection", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ImageKernelProductDetection>): ImageKernelProductDetection {
        const message = { enabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelProductDetection>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelProductDetection): ImageKernelProductDetection {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelProductDetection, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelProductDetection
 */
export const ImageKernelProductDetection = new ImageKernelProductDetection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageKernelSetting$Type extends MessageType<ImageKernelSetting> {
    constructor() {
        super("brandguard.kernel.ImageKernelSetting", [
            { no: 1, name: "id", kind: "scalar", jsonName: "kernel_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "threshold", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "brand_voice", kind: "message", localName: "brand_voice", jsonName: "brand_voice", T: () => ImageKernelScoringEnabled },
            { no: 4, name: "sexually_explicit", kind: "message", localName: "sexually_explicit", jsonName: "sexually_explicit", T: () => ImageKernelScoringEnabled },
            { no: 5, name: "image_quality_general", kind: "message", localName: "image_quality_general", jsonName: "quality_general", T: () => ImageKernelScoringEnabled },
            { no: 6, name: "image_violence", kind: "message", localName: "image_violence", jsonName: "image_violence", T: () => ImageKernelScoringEnabled },
            { no: 7, name: "image_logo_detection", kind: "message", localName: "image_logo_detection", jsonName: "image_logo_detection", T: () => ImageKernelLogosEnabled },
            { no: 8, name: "image_lookandfeel", kind: "message", localName: "image_lookandfeel", jsonName: "image_lookandfeel", T: () => ImageKernelLookandFeelEnabled },
            { no: 9, name: "image_font_detection", kind: "message", localName: "image_font_detection", jsonName: "image_font_detection", T: () => ImageKernelFontEnabled },
            { no: 10, name: "image_background_colors", kind: "message", localName: "image_background_colors", jsonName: "image_background_colors", T: () => ImageKernelBackgroundColorEnabled },
            { no: 11, name: "brand_consistency", kind: "message", localName: "brand_consistency", jsonName: "brand_consistency", T: () => ImageKernelScoringEnabled },
            { no: 12, name: "image_onbrand", kind: "message", localName: "image_onbrand", jsonName: "image_onbrand", T: () => ImageKernelScoringEnabled },
            { no: 13, name: "product_detection", kind: "message", localName: "product_detection", jsonName: "product_detection", T: () => ImageKernelProductDetection },
            { no: 14, name: "ai_generated", kind: "message", localName: "ai_generated", jsonName: "ai_generated", T: () => ImageKernelScoringEnabled },
            { no: 15, name: "copy_tone_and_voice", kind: "message", localName: "copy_tone_and_voice", jsonName: "copy_tone_and_voice", T: () => ImageKernelScoringToneAndVoice }
        ]);
    }
    create(value?: PartialMessage<ImageKernelSetting>): ImageKernelSetting {
        const message = { id: "", threshold: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ImageKernelSetting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImageKernelSetting): ImageKernelSetting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id = 1 [json_name = "kernel_id"];*/ 1:
                    message.id = reader.string();
                    break;
                case /* int32 threshold */ 2:
                    message.threshold = reader.int32();
                    break;
                case /* brandguard.kernel.ImageKernelScoringEnabled brand_voice = 3 [json_name = "brand_voice"];*/ 3:
                    message.brand_voice = ImageKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.brand_voice);
                    break;
                case /* brandguard.kernel.ImageKernelScoringEnabled sexually_explicit = 4 [json_name = "sexually_explicit"];*/ 4:
                    message.sexually_explicit = ImageKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.sexually_explicit);
                    break;
                case /* brandguard.kernel.ImageKernelScoringEnabled image_quality_general = 5 [json_name = "quality_general"];*/ 5:
                    message.image_quality_general = ImageKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.image_quality_general);
                    break;
                case /* brandguard.kernel.ImageKernelScoringEnabled image_violence = 6 [json_name = "image_violence"];*/ 6:
                    message.image_violence = ImageKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.image_violence);
                    break;
                case /* brandguard.kernel.ImageKernelLogosEnabled image_logo_detection = 7 [json_name = "image_logo_detection"];*/ 7:
                    message.image_logo_detection = ImageKernelLogosEnabled.internalBinaryRead(reader, reader.uint32(), options, message.image_logo_detection);
                    break;
                case /* brandguard.kernel.ImageKernelLookandFeelEnabled image_lookandfeel = 8 [json_name = "image_lookandfeel"];*/ 8:
                    message.image_lookandfeel = ImageKernelLookandFeelEnabled.internalBinaryRead(reader, reader.uint32(), options, message.image_lookandfeel);
                    break;
                case /* brandguard.kernel.ImageKernelFontEnabled image_font_detection = 9 [json_name = "image_font_detection"];*/ 9:
                    message.image_font_detection = ImageKernelFontEnabled.internalBinaryRead(reader, reader.uint32(), options, message.image_font_detection);
                    break;
                case /* brandguard.kernel.ImageKernelBackgroundColorEnabled image_background_colors = 10 [json_name = "image_background_colors"];*/ 10:
                    message.image_background_colors = ImageKernelBackgroundColorEnabled.internalBinaryRead(reader, reader.uint32(), options, message.image_background_colors);
                    break;
                case /* brandguard.kernel.ImageKernelScoringEnabled brand_consistency = 11 [json_name = "brand_consistency"];*/ 11:
                    message.brand_consistency = ImageKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.brand_consistency);
                    break;
                case /* brandguard.kernel.ImageKernelScoringEnabled image_onbrand = 12 [json_name = "image_onbrand"];*/ 12:
                    message.image_onbrand = ImageKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.image_onbrand);
                    break;
                case /* brandguard.kernel.ImageKernelProductDetection product_detection = 13 [json_name = "product_detection"];*/ 13:
                    message.product_detection = ImageKernelProductDetection.internalBinaryRead(reader, reader.uint32(), options, message.product_detection);
                    break;
                case /* brandguard.kernel.ImageKernelScoringEnabled ai_generated = 14 [json_name = "ai_generated"];*/ 14:
                    message.ai_generated = ImageKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.ai_generated);
                    break;
                case /* brandguard.kernel.ImageKernelScoringToneAndVoice copy_tone_and_voice = 15 [json_name = "copy_tone_and_voice"];*/ 15:
                    message.copy_tone_and_voice = ImageKernelScoringToneAndVoice.internalBinaryRead(reader, reader.uint32(), options, message.copy_tone_and_voice);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImageKernelSetting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1 [json_name = "kernel_id"]; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* int32 threshold = 2; */
        if (message.threshold !== 0)
            writer.tag(2, WireType.Varint).int32(message.threshold);
        /* brandguard.kernel.ImageKernelScoringEnabled brand_voice = 3 [json_name = "brand_voice"]; */
        if (message.brand_voice)
            ImageKernelScoringEnabled.internalBinaryWrite(message.brand_voice, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelScoringEnabled sexually_explicit = 4 [json_name = "sexually_explicit"]; */
        if (message.sexually_explicit)
            ImageKernelScoringEnabled.internalBinaryWrite(message.sexually_explicit, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelScoringEnabled image_quality_general = 5 [json_name = "quality_general"]; */
        if (message.image_quality_general)
            ImageKernelScoringEnabled.internalBinaryWrite(message.image_quality_general, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelScoringEnabled image_violence = 6 [json_name = "image_violence"]; */
        if (message.image_violence)
            ImageKernelScoringEnabled.internalBinaryWrite(message.image_violence, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelLogosEnabled image_logo_detection = 7 [json_name = "image_logo_detection"]; */
        if (message.image_logo_detection)
            ImageKernelLogosEnabled.internalBinaryWrite(message.image_logo_detection, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelLookandFeelEnabled image_lookandfeel = 8 [json_name = "image_lookandfeel"]; */
        if (message.image_lookandfeel)
            ImageKernelLookandFeelEnabled.internalBinaryWrite(message.image_lookandfeel, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelFontEnabled image_font_detection = 9 [json_name = "image_font_detection"]; */
        if (message.image_font_detection)
            ImageKernelFontEnabled.internalBinaryWrite(message.image_font_detection, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelBackgroundColorEnabled image_background_colors = 10 [json_name = "image_background_colors"]; */
        if (message.image_background_colors)
            ImageKernelBackgroundColorEnabled.internalBinaryWrite(message.image_background_colors, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelScoringEnabled brand_consistency = 11 [json_name = "brand_consistency"]; */
        if (message.brand_consistency)
            ImageKernelScoringEnabled.internalBinaryWrite(message.brand_consistency, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelScoringEnabled image_onbrand = 12 [json_name = "image_onbrand"]; */
        if (message.image_onbrand)
            ImageKernelScoringEnabled.internalBinaryWrite(message.image_onbrand, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelProductDetection product_detection = 13 [json_name = "product_detection"]; */
        if (message.product_detection)
            ImageKernelProductDetection.internalBinaryWrite(message.product_detection, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelScoringEnabled ai_generated = 14 [json_name = "ai_generated"]; */
        if (message.ai_generated)
            ImageKernelScoringEnabled.internalBinaryWrite(message.ai_generated, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.ImageKernelScoringToneAndVoice copy_tone_and_voice = 15 [json_name = "copy_tone_and_voice"]; */
        if (message.copy_tone_and_voice)
            ImageKernelScoringToneAndVoice.internalBinaryWrite(message.copy_tone_and_voice, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.ImageKernelSetting
 */
export const ImageKernelSetting = new ImageKernelSetting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelScoringEnabled$Type extends MessageType<DocumentKernelScoringEnabled> {
    constructor() {
        super("brandguard.kernel.DocumentKernelScoringEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelScoringEnabled>): DocumentKernelScoringEnabled {
        const message = { enabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelScoringEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelScoringEnabled): DocumentKernelScoringEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelScoringEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelScoringEnabled
 */
export const DocumentKernelScoringEnabled = new DocumentKernelScoringEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelLookandFeelRule$Type extends MessageType<DocumentKernelLookandFeelRule> {
    constructor() {
        super("brandguard.kernel.DocumentKernelLookandFeelRule", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rule", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelLookandFeelRule>): DocumentKernelLookandFeelRule {
        const message = { id: "", description: "", rule: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelLookandFeelRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelLookandFeelRule): DocumentKernelLookandFeelRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string rule */ 3:
                    message.rule = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelLookandFeelRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string rule = 3; */
        if (message.rule !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rule);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelLookandFeelRule
 */
export const DocumentKernelLookandFeelRule = new DocumentKernelLookandFeelRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelLookandFeelEnabled$Type extends MessageType<DocumentKernelLookandFeelEnabled> {
    constructor() {
        super("brandguard.kernel.DocumentKernelLookandFeelEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "rules", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentKernelLookandFeelRule }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelLookandFeelEnabled>): DocumentKernelLookandFeelEnabled {
        const message = { enabled: false, rules: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelLookandFeelEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelLookandFeelEnabled): DocumentKernelLookandFeelEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.DocumentKernelLookandFeelRule rules */ 2:
                    message.rules.push(DocumentKernelLookandFeelRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelLookandFeelEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.DocumentKernelLookandFeelRule rules = 2; */
        for (let i = 0; i < message.rules.length; i++)
            DocumentKernelLookandFeelRule.internalBinaryWrite(message.rules[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelLookandFeelEnabled
 */
export const DocumentKernelLookandFeelEnabled = new DocumentKernelLookandFeelEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelLogo$Type extends MessageType<DocumentKernelLogo> {
    constructor() {
        super("brandguard.kernel.DocumentKernelLogo", [
            { no: 1, name: "mimetype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "md5", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "image", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "clearspace", kind: "message", T: () => ImageClearspace },
            { no: 6, name: "usage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelLogo>): DocumentKernelLogo {
        const message = { mimetype: "", md5: "", description: "", image: "", usage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelLogo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelLogo): DocumentKernelLogo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string mimetype */ 1:
                    message.mimetype = reader.string();
                    break;
                case /* string md5 */ 2:
                    message.md5 = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string image */ 4:
                    message.image = reader.string();
                    break;
                case /* brandguard.kernel.ImageClearspace clearspace */ 5:
                    message.clearspace = ImageClearspace.internalBinaryRead(reader, reader.uint32(), options, message.clearspace);
                    break;
                case /* string usage */ 6:
                    message.usage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelLogo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string mimetype = 1; */
        if (message.mimetype !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.mimetype);
        /* string md5 = 2; */
        if (message.md5 !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.md5);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string image = 4; */
        if (message.image !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.image);
        /* brandguard.kernel.ImageClearspace clearspace = 5; */
        if (message.clearspace)
            ImageClearspace.internalBinaryWrite(message.clearspace, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string usage = 6; */
        if (message.usage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelLogo
 */
export const DocumentKernelLogo = new DocumentKernelLogo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelLogosEnabled$Type extends MessageType<DocumentKernelLogosEnabled> {
    constructor() {
        super("brandguard.kernel.DocumentKernelLogosEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "logos", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentKernelLogo }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelLogosEnabled>): DocumentKernelLogosEnabled {
        const message = { enabled: false, logos: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelLogosEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelLogosEnabled): DocumentKernelLogosEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.DocumentKernelLogo logos */ 2:
                    message.logos.push(DocumentKernelLogo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelLogosEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.DocumentKernelLogo logos = 2; */
        for (let i = 0; i < message.logos.length; i++)
            DocumentKernelLogo.internalBinaryWrite(message.logos[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelLogosEnabled
 */
export const DocumentKernelLogosEnabled = new DocumentKernelLogosEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelFont$Type extends MessageType<DocumentKernelFont> {
    constructor() {
        super("brandguard.kernel.DocumentKernelFont", [
            { no: 1, name: "md5", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mimetype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "font", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "style_regular", kind: "scalar", localName: "style_regular", jsonName: "style_regular", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "style_bold", kind: "scalar", localName: "style_bold", jsonName: "style_bold", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "style_italic", kind: "scalar", localName: "style_italic", jsonName: "style_italic", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "style_light", kind: "scalar", localName: "style_light", jsonName: "style_light", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "usage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelFont>): DocumentKernelFont {
        const message = { md5: "", mimetype: "", description: "", font: "", style_regular: false, style_bold: false, style_italic: false, style_light: false, usage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelFont>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelFont): DocumentKernelFont {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string md5 */ 1:
                    message.md5 = reader.string();
                    break;
                case /* string mimetype */ 2:
                    message.mimetype = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string font */ 4:
                    message.font = reader.string();
                    break;
                case /* bool style_regular = 5 [json_name = "style_regular"];*/ 5:
                    message.style_regular = reader.bool();
                    break;
                case /* bool style_bold = 6 [json_name = "style_bold"];*/ 6:
                    message.style_bold = reader.bool();
                    break;
                case /* bool style_italic = 7 [json_name = "style_italic"];*/ 7:
                    message.style_italic = reader.bool();
                    break;
                case /* bool style_light = 8 [json_name = "style_light"];*/ 8:
                    message.style_light = reader.bool();
                    break;
                case /* string usage */ 9:
                    message.usage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelFont, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string md5 = 1; */
        if (message.md5 !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.md5);
        /* string mimetype = 2; */
        if (message.mimetype !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mimetype);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string font = 4; */
        if (message.font !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.font);
        /* bool style_regular = 5 [json_name = "style_regular"]; */
        if (message.style_regular !== false)
            writer.tag(5, WireType.Varint).bool(message.style_regular);
        /* bool style_bold = 6 [json_name = "style_bold"]; */
        if (message.style_bold !== false)
            writer.tag(6, WireType.Varint).bool(message.style_bold);
        /* bool style_italic = 7 [json_name = "style_italic"]; */
        if (message.style_italic !== false)
            writer.tag(7, WireType.Varint).bool(message.style_italic);
        /* bool style_light = 8 [json_name = "style_light"]; */
        if (message.style_light !== false)
            writer.tag(8, WireType.Varint).bool(message.style_light);
        /* string usage = 9; */
        if (message.usage !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelFont
 */
export const DocumentKernelFont = new DocumentKernelFont$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelFontEnabled$Type extends MessageType<DocumentKernelFontEnabled> {
    constructor() {
        super("brandguard.kernel.DocumentKernelFontEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "fonts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentKernelFont }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelFontEnabled>): DocumentKernelFontEnabled {
        const message = { enabled: false, fonts: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelFontEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelFontEnabled): DocumentKernelFontEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.DocumentKernelFont fonts */ 2:
                    message.fonts.push(DocumentKernelFont.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelFontEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.DocumentKernelFont fonts = 2; */
        for (let i = 0; i < message.fonts.length; i++)
            DocumentKernelFont.internalBinaryWrite(message.fonts[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelFontEnabled
 */
export const DocumentKernelFontEnabled = new DocumentKernelFontEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelBackgroundColor$Type extends MessageType<DocumentKernelBackgroundColor> {
    constructor() {
        super("brandguard.kernel.DocumentKernelBackgroundColor", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "usage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelBackgroundColor>): DocumentKernelBackgroundColor {
        const message = { id: "", color: "", description: "", usage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelBackgroundColor>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelBackgroundColor): DocumentKernelBackgroundColor {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string color */ 2:
                    message.color = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string usage */ 4:
                    message.usage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelBackgroundColor, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string color = 2; */
        if (message.color !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.color);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string usage = 4; */
        if (message.usage !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelBackgroundColor
 */
export const DocumentKernelBackgroundColor = new DocumentKernelBackgroundColor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelBackgroundColorEnabled$Type extends MessageType<DocumentKernelBackgroundColorEnabled> {
    constructor() {
        super("brandguard.kernel.DocumentKernelBackgroundColorEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "colors", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentKernelBackgroundColor }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelBackgroundColorEnabled>): DocumentKernelBackgroundColorEnabled {
        const message = { enabled: false, colors: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelBackgroundColorEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelBackgroundColorEnabled): DocumentKernelBackgroundColorEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.DocumentKernelBackgroundColor colors */ 2:
                    message.colors.push(DocumentKernelBackgroundColor.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelBackgroundColorEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.DocumentKernelBackgroundColor colors = 2; */
        for (let i = 0; i < message.colors.length; i++)
            DocumentKernelBackgroundColor.internalBinaryWrite(message.colors[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelBackgroundColorEnabled
 */
export const DocumentKernelBackgroundColorEnabled = new DocumentKernelBackgroundColorEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelRule$Type extends MessageType<DocumentKernelRule> {
    constructor() {
        super("brandguard.kernel.DocumentKernelRule", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rule", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelRule>): DocumentKernelRule {
        const message = { id: "", description: "", rule: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelRule): DocumentKernelRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string rule */ 3:
                    message.rule = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string rule = 3; */
        if (message.rule !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rule);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelRule
 */
export const DocumentKernelRule = new DocumentKernelRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelRulesEnabled$Type extends MessageType<DocumentKernelRulesEnabled> {
    constructor() {
        super("brandguard.kernel.DocumentKernelRulesEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "rules", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentKernelRule }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelRulesEnabled>): DocumentKernelRulesEnabled {
        const message = { enabled: false, rules: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelRulesEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelRulesEnabled): DocumentKernelRulesEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.DocumentKernelRule rules */ 2:
                    message.rules.push(DocumentKernelRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelRulesEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.DocumentKernelRule rules = 2; */
        for (let i = 0; i < message.rules.length; i++)
            DocumentKernelRule.internalBinaryWrite(message.rules[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelRulesEnabled
 */
export const DocumentKernelRulesEnabled = new DocumentKernelRulesEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelProductDetection$Type extends MessageType<DocumentKernelProductDetection> {
    constructor() {
        super("brandguard.kernel.DocumentKernelProductDetection", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelProductDetection>): DocumentKernelProductDetection {
        const message = { enabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelProductDetection>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelProductDetection): DocumentKernelProductDetection {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelProductDetection, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelProductDetection
 */
export const DocumentKernelProductDetection = new DocumentKernelProductDetection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelSetting$Type extends MessageType<DocumentKernelSetting> {
    constructor() {
        super("brandguard.kernel.DocumentKernelSetting", [
            { no: 1, name: "id", kind: "scalar", jsonName: "kernel_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "threshold", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "doc_brand_voice", kind: "message", localName: "doc_brand_voice", jsonName: "doc_brand_voice", T: () => DocumentKernelScoringEnabled },
            { no: 4, name: "doc_nudity", kind: "message", localName: "doc_nudity", jsonName: "doc_nudity", T: () => DocumentKernelScoringEnabled },
            { no: 5, name: "doc_violence", kind: "message", localName: "doc_violence", jsonName: "doc_violence", T: () => DocumentKernelScoringEnabled },
            { no: 6, name: "doc_racism", kind: "message", localName: "doc_racism", jsonName: "doc_racism", T: () => DocumentKernelScoringEnabled },
            { no: 7, name: "doc_grammar", kind: "message", localName: "doc_grammar", jsonName: "doc_grammar", T: () => DocumentKernelScoringEnabled },
            { no: 8, name: "doc_lookandfeel", kind: "message", localName: "doc_lookandfeel", jsonName: "doc_lookandfeel", T: () => DocumentKernelLookandFeelEnabled },
            { no: 9, name: "doc_logo_detection", kind: "message", localName: "doc_logo_detection", jsonName: "doc_logo_detection", T: () => DocumentKernelLogosEnabled },
            { no: 10, name: "doc_font_detection", kind: "message", localName: "doc_font_detection", jsonName: "doc_font_detection", T: () => DocumentKernelFontEnabled },
            { no: 11, name: "doc_rules", kind: "message", localName: "doc_rules", jsonName: "doc_rules", T: () => DocumentKernelRulesEnabled },
            { no: 12, name: "brand_consistency", kind: "message", localName: "brand_consistency", jsonName: "brand_consistency", T: () => DocumentKernelScoringEnabled },
            { no: 13, name: "product_detection", kind: "message", localName: "product_detection", jsonName: "product_detection", T: () => DocumentKernelProductDetection },
            { no: 14, name: "ai_generated", kind: "message", localName: "ai_generated", jsonName: "ai_generated", T: () => DocumentKernelScoringEnabled },
            { no: 15, name: "doc_background_colors", kind: "message", localName: "doc_background_colors", jsonName: "doc_background_colors", T: () => DocumentKernelBackgroundColorEnabled }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelSetting>): DocumentKernelSetting {
        const message = { id: "", threshold: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelSetting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelSetting): DocumentKernelSetting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id = 1 [json_name = "kernel_id"];*/ 1:
                    message.id = reader.string();
                    break;
                case /* int32 threshold */ 2:
                    message.threshold = reader.int32();
                    break;
                case /* brandguard.kernel.DocumentKernelScoringEnabled doc_brand_voice = 3 [json_name = "doc_brand_voice"];*/ 3:
                    message.doc_brand_voice = DocumentKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_brand_voice);
                    break;
                case /* brandguard.kernel.DocumentKernelScoringEnabled doc_nudity = 4 [json_name = "doc_nudity"];*/ 4:
                    message.doc_nudity = DocumentKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_nudity);
                    break;
                case /* brandguard.kernel.DocumentKernelScoringEnabled doc_violence = 5 [json_name = "doc_violence"];*/ 5:
                    message.doc_violence = DocumentKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_violence);
                    break;
                case /* brandguard.kernel.DocumentKernelScoringEnabled doc_racism = 6 [json_name = "doc_racism"];*/ 6:
                    message.doc_racism = DocumentKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_racism);
                    break;
                case /* brandguard.kernel.DocumentKernelScoringEnabled doc_grammar = 7 [json_name = "doc_grammar"];*/ 7:
                    message.doc_grammar = DocumentKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_grammar);
                    break;
                case /* brandguard.kernel.DocumentKernelLookandFeelEnabled doc_lookandfeel = 8 [json_name = "doc_lookandfeel"];*/ 8:
                    message.doc_lookandfeel = DocumentKernelLookandFeelEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_lookandfeel);
                    break;
                case /* brandguard.kernel.DocumentKernelLogosEnabled doc_logo_detection = 9 [json_name = "doc_logo_detection"];*/ 9:
                    message.doc_logo_detection = DocumentKernelLogosEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_logo_detection);
                    break;
                case /* brandguard.kernel.DocumentKernelFontEnabled doc_font_detection = 10 [json_name = "doc_font_detection"];*/ 10:
                    message.doc_font_detection = DocumentKernelFontEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_font_detection);
                    break;
                case /* brandguard.kernel.DocumentKernelRulesEnabled doc_rules = 11 [json_name = "doc_rules"];*/ 11:
                    message.doc_rules = DocumentKernelRulesEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_rules);
                    break;
                case /* brandguard.kernel.DocumentKernelScoringEnabled brand_consistency = 12 [json_name = "brand_consistency"];*/ 12:
                    message.brand_consistency = DocumentKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.brand_consistency);
                    break;
                case /* brandguard.kernel.DocumentKernelProductDetection product_detection = 13 [json_name = "product_detection"];*/ 13:
                    message.product_detection = DocumentKernelProductDetection.internalBinaryRead(reader, reader.uint32(), options, message.product_detection);
                    break;
                case /* brandguard.kernel.DocumentKernelScoringEnabled ai_generated = 14 [json_name = "ai_generated"];*/ 14:
                    message.ai_generated = DocumentKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.ai_generated);
                    break;
                case /* brandguard.kernel.DocumentKernelBackgroundColorEnabled doc_background_colors = 15 [json_name = "doc_background_colors"];*/ 15:
                    message.doc_background_colors = DocumentKernelBackgroundColorEnabled.internalBinaryRead(reader, reader.uint32(), options, message.doc_background_colors);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelSetting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1 [json_name = "kernel_id"]; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* int32 threshold = 2; */
        if (message.threshold !== 0)
            writer.tag(2, WireType.Varint).int32(message.threshold);
        /* brandguard.kernel.DocumentKernelScoringEnabled doc_brand_voice = 3 [json_name = "doc_brand_voice"]; */
        if (message.doc_brand_voice)
            DocumentKernelScoringEnabled.internalBinaryWrite(message.doc_brand_voice, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelScoringEnabled doc_nudity = 4 [json_name = "doc_nudity"]; */
        if (message.doc_nudity)
            DocumentKernelScoringEnabled.internalBinaryWrite(message.doc_nudity, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelScoringEnabled doc_violence = 5 [json_name = "doc_violence"]; */
        if (message.doc_violence)
            DocumentKernelScoringEnabled.internalBinaryWrite(message.doc_violence, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelScoringEnabled doc_racism = 6 [json_name = "doc_racism"]; */
        if (message.doc_racism)
            DocumentKernelScoringEnabled.internalBinaryWrite(message.doc_racism, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelScoringEnabled doc_grammar = 7 [json_name = "doc_grammar"]; */
        if (message.doc_grammar)
            DocumentKernelScoringEnabled.internalBinaryWrite(message.doc_grammar, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelLookandFeelEnabled doc_lookandfeel = 8 [json_name = "doc_lookandfeel"]; */
        if (message.doc_lookandfeel)
            DocumentKernelLookandFeelEnabled.internalBinaryWrite(message.doc_lookandfeel, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelLogosEnabled doc_logo_detection = 9 [json_name = "doc_logo_detection"]; */
        if (message.doc_logo_detection)
            DocumentKernelLogosEnabled.internalBinaryWrite(message.doc_logo_detection, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelFontEnabled doc_font_detection = 10 [json_name = "doc_font_detection"]; */
        if (message.doc_font_detection)
            DocumentKernelFontEnabled.internalBinaryWrite(message.doc_font_detection, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelRulesEnabled doc_rules = 11 [json_name = "doc_rules"]; */
        if (message.doc_rules)
            DocumentKernelRulesEnabled.internalBinaryWrite(message.doc_rules, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelScoringEnabled brand_consistency = 12 [json_name = "brand_consistency"]; */
        if (message.brand_consistency)
            DocumentKernelScoringEnabled.internalBinaryWrite(message.brand_consistency, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelProductDetection product_detection = 13 [json_name = "product_detection"]; */
        if (message.product_detection)
            DocumentKernelProductDetection.internalBinaryWrite(message.product_detection, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelScoringEnabled ai_generated = 14 [json_name = "ai_generated"]; */
        if (message.ai_generated)
            DocumentKernelScoringEnabled.internalBinaryWrite(message.ai_generated, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.DocumentKernelBackgroundColorEnabled doc_background_colors = 15 [json_name = "doc_background_colors"]; */
        if (message.doc_background_colors)
            DocumentKernelBackgroundColorEnabled.internalBinaryWrite(message.doc_background_colors, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.DocumentKernelSetting
 */
export const DocumentKernelSetting = new DocumentKernelSetting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelScoringEnabled$Type extends MessageType<VideoKernelScoringEnabled> {
    constructor() {
        super("brandguard.kernel.VideoKernelScoringEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<VideoKernelScoringEnabled>): VideoKernelScoringEnabled {
        const message = { enabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelScoringEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelScoringEnabled): VideoKernelScoringEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelScoringEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelScoringEnabled
 */
export const VideoKernelScoringEnabled = new VideoKernelScoringEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelLogo$Type extends MessageType<VideoKernelLogo> {
    constructor() {
        super("brandguard.kernel.VideoKernelLogo", [
            { no: 1, name: "mimetype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "md5", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "image", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "clearspace", kind: "message", T: () => ImageClearspace },
            { no: 6, name: "usage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VideoKernelLogo>): VideoKernelLogo {
        const message = { mimetype: "", md5: "", description: "", image: "", usage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelLogo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelLogo): VideoKernelLogo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string mimetype */ 1:
                    message.mimetype = reader.string();
                    break;
                case /* string md5 */ 2:
                    message.md5 = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string image */ 4:
                    message.image = reader.string();
                    break;
                case /* brandguard.kernel.ImageClearspace clearspace */ 5:
                    message.clearspace = ImageClearspace.internalBinaryRead(reader, reader.uint32(), options, message.clearspace);
                    break;
                case /* string usage */ 6:
                    message.usage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelLogo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string mimetype = 1; */
        if (message.mimetype !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.mimetype);
        /* string md5 = 2; */
        if (message.md5 !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.md5);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string image = 4; */
        if (message.image !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.image);
        /* brandguard.kernel.ImageClearspace clearspace = 5; */
        if (message.clearspace)
            ImageClearspace.internalBinaryWrite(message.clearspace, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string usage = 6; */
        if (message.usage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelLogo
 */
export const VideoKernelLogo = new VideoKernelLogo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelLogosEnabled$Type extends MessageType<VideoKernelLogosEnabled> {
    constructor() {
        super("brandguard.kernel.VideoKernelLogosEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "logos", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VideoKernelLogo }
        ]);
    }
    create(value?: PartialMessage<VideoKernelLogosEnabled>): VideoKernelLogosEnabled {
        const message = { enabled: false, logos: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelLogosEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelLogosEnabled): VideoKernelLogosEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.VideoKernelLogo logos */ 2:
                    message.logos.push(VideoKernelLogo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelLogosEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.VideoKernelLogo logos = 2; */
        for (let i = 0; i < message.logos.length; i++)
            VideoKernelLogo.internalBinaryWrite(message.logos[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelLogosEnabled
 */
export const VideoKernelLogosEnabled = new VideoKernelLogosEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelFont$Type extends MessageType<VideoKernelFont> {
    constructor() {
        super("brandguard.kernel.VideoKernelFont", [
            { no: 1, name: "md5", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mimetype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "font", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "style_regular", kind: "scalar", localName: "style_regular", jsonName: "style_regular", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "style_bold", kind: "scalar", localName: "style_bold", jsonName: "style_bold", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "style_italic", kind: "scalar", localName: "style_italic", jsonName: "style_italic", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "style_light", kind: "scalar", localName: "style_light", jsonName: "style_light", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "usage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VideoKernelFont>): VideoKernelFont {
        const message = { md5: "", mimetype: "", description: "", font: "", style_regular: false, style_bold: false, style_italic: false, style_light: false, usage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelFont>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelFont): VideoKernelFont {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string md5 */ 1:
                    message.md5 = reader.string();
                    break;
                case /* string mimetype */ 2:
                    message.mimetype = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string font */ 4:
                    message.font = reader.string();
                    break;
                case /* bool style_regular = 5 [json_name = "style_regular"];*/ 5:
                    message.style_regular = reader.bool();
                    break;
                case /* bool style_bold = 6 [json_name = "style_bold"];*/ 6:
                    message.style_bold = reader.bool();
                    break;
                case /* bool style_italic = 7 [json_name = "style_italic"];*/ 7:
                    message.style_italic = reader.bool();
                    break;
                case /* bool style_light = 8 [json_name = "style_light"];*/ 8:
                    message.style_light = reader.bool();
                    break;
                case /* string usage */ 9:
                    message.usage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelFont, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string md5 = 1; */
        if (message.md5 !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.md5);
        /* string mimetype = 2; */
        if (message.mimetype !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mimetype);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string font = 4; */
        if (message.font !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.font);
        /* bool style_regular = 5 [json_name = "style_regular"]; */
        if (message.style_regular !== false)
            writer.tag(5, WireType.Varint).bool(message.style_regular);
        /* bool style_bold = 6 [json_name = "style_bold"]; */
        if (message.style_bold !== false)
            writer.tag(6, WireType.Varint).bool(message.style_bold);
        /* bool style_italic = 7 [json_name = "style_italic"]; */
        if (message.style_italic !== false)
            writer.tag(7, WireType.Varint).bool(message.style_italic);
        /* bool style_light = 8 [json_name = "style_light"]; */
        if (message.style_light !== false)
            writer.tag(8, WireType.Varint).bool(message.style_light);
        /* string usage = 9; */
        if (message.usage !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelFont
 */
export const VideoKernelFont = new VideoKernelFont$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelFontEnabled$Type extends MessageType<VideoKernelFontEnabled> {
    constructor() {
        super("brandguard.kernel.VideoKernelFontEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "fonts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VideoKernelFont }
        ]);
    }
    create(value?: PartialMessage<VideoKernelFontEnabled>): VideoKernelFontEnabled {
        const message = { enabled: false, fonts: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelFontEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelFontEnabled): VideoKernelFontEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.VideoKernelFont fonts */ 2:
                    message.fonts.push(VideoKernelFont.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelFontEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.VideoKernelFont fonts = 2; */
        for (let i = 0; i < message.fonts.length; i++)
            VideoKernelFont.internalBinaryWrite(message.fonts[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelFontEnabled
 */
export const VideoKernelFontEnabled = new VideoKernelFontEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelBackgroundColor$Type extends MessageType<VideoKernelBackgroundColor> {
    constructor() {
        super("brandguard.kernel.VideoKernelBackgroundColor", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "usage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VideoKernelBackgroundColor>): VideoKernelBackgroundColor {
        const message = { id: "", color: "", description: "", usage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelBackgroundColor>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelBackgroundColor): VideoKernelBackgroundColor {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string color */ 2:
                    message.color = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string usage */ 4:
                    message.usage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelBackgroundColor, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string color = 2; */
        if (message.color !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.color);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string usage = 4; */
        if (message.usage !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelBackgroundColor
 */
export const VideoKernelBackgroundColor = new VideoKernelBackgroundColor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelBackgroundColorEnabled$Type extends MessageType<VideoKernelBackgroundColorEnabled> {
    constructor() {
        super("brandguard.kernel.VideoKernelBackgroundColorEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "colors", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VideoKernelBackgroundColor }
        ]);
    }
    create(value?: PartialMessage<VideoKernelBackgroundColorEnabled>): VideoKernelBackgroundColorEnabled {
        const message = { enabled: false, colors: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelBackgroundColorEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelBackgroundColorEnabled): VideoKernelBackgroundColorEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.VideoKernelBackgroundColor colors */ 2:
                    message.colors.push(VideoKernelBackgroundColor.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelBackgroundColorEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.VideoKernelBackgroundColor colors = 2; */
        for (let i = 0; i < message.colors.length; i++)
            VideoKernelBackgroundColor.internalBinaryWrite(message.colors[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelBackgroundColorEnabled
 */
export const VideoKernelBackgroundColorEnabled = new VideoKernelBackgroundColorEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelLookandFeelRule$Type extends MessageType<VideoKernelLookandFeelRule> {
    constructor() {
        super("brandguard.kernel.VideoKernelLookandFeelRule", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rule", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VideoKernelLookandFeelRule>): VideoKernelLookandFeelRule {
        const message = { id: "", description: "", rule: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelLookandFeelRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelLookandFeelRule): VideoKernelLookandFeelRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string rule */ 3:
                    message.rule = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelLookandFeelRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string rule = 3; */
        if (message.rule !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rule);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelLookandFeelRule
 */
export const VideoKernelLookandFeelRule = new VideoKernelLookandFeelRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelLookandFeelEnabled$Type extends MessageType<VideoKernelLookandFeelEnabled> {
    constructor() {
        super("brandguard.kernel.VideoKernelLookandFeelEnabled", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "rules", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VideoKernelLookandFeelRule }
        ]);
    }
    create(value?: PartialMessage<VideoKernelLookandFeelEnabled>): VideoKernelLookandFeelEnabled {
        const message = { enabled: false, rules: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelLookandFeelEnabled>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelLookandFeelEnabled): VideoKernelLookandFeelEnabled {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated brandguard.kernel.VideoKernelLookandFeelRule rules */ 2:
                    message.rules.push(VideoKernelLookandFeelRule.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelLookandFeelEnabled, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated brandguard.kernel.VideoKernelLookandFeelRule rules = 2; */
        for (let i = 0; i < message.rules.length; i++)
            VideoKernelLookandFeelRule.internalBinaryWrite(message.rules[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelLookandFeelEnabled
 */
export const VideoKernelLookandFeelEnabled = new VideoKernelLookandFeelEnabled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelProductDetection$Type extends MessageType<VideoKernelProductDetection> {
    constructor() {
        super("brandguard.kernel.VideoKernelProductDetection", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<VideoKernelProductDetection>): VideoKernelProductDetection {
        const message = { enabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelProductDetection>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelProductDetection): VideoKernelProductDetection {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelProductDetection, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelProductDetection
 */
export const VideoKernelProductDetection = new VideoKernelProductDetection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelSetting$Type extends MessageType<VideoKernelSetting> {
    constructor() {
        super("brandguard.kernel.VideoKernelSetting", [
            { no: 1, name: "id", kind: "scalar", jsonName: "kernel_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "threshold", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "brand_voice", kind: "message", localName: "brand_voice", jsonName: "brand_voice", T: () => VideoKernelScoringEnabled },
            { no: 4, name: "sexually_explicit", kind: "message", localName: "sexually_explicit", jsonName: "sexually_explicit", T: () => VideoKernelScoringEnabled },
            { no: 5, name: "video_quality_general", kind: "message", localName: "video_quality_general", jsonName: "quality_general", T: () => VideoKernelScoringEnabled },
            { no: 6, name: "video_violence", kind: "message", localName: "video_violence", jsonName: "video_violence", T: () => VideoKernelScoringEnabled },
            { no: 7, name: "video_logo_detection", kind: "message", localName: "video_logo_detection", jsonName: "video_logo_detection", T: () => VideoKernelLogosEnabled },
            { no: 8, name: "video_lookandfeel", kind: "message", localName: "video_lookandfeel", jsonName: "video_lookandfeel", T: () => VideoKernelLookandFeelEnabled },
            { no: 9, name: "video_font_detection", kind: "message", localName: "video_font_detection", jsonName: "video_font_detection", T: () => VideoKernelFontEnabled },
            { no: 10, name: "video_background_colors", kind: "message", localName: "video_background_colors", jsonName: "video_background_colors", T: () => VideoKernelBackgroundColorEnabled },
            { no: 11, name: "brand_consistency", kind: "message", localName: "brand_consistency", jsonName: "brand_consistency", T: () => VideoKernelScoringEnabled },
            { no: 12, name: "product_detection", kind: "message", localName: "product_detection", jsonName: "product_detection", T: () => VideoKernelProductDetection },
            { no: 13, name: "ai_generated", kind: "message", localName: "ai_generated", jsonName: "ai_generated", T: () => VideoKernelScoringEnabled }
        ]);
    }
    create(value?: PartialMessage<VideoKernelSetting>): VideoKernelSetting {
        const message = { id: "", threshold: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelSetting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelSetting): VideoKernelSetting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id = 1 [json_name = "kernel_id"];*/ 1:
                    message.id = reader.string();
                    break;
                case /* int32 threshold */ 2:
                    message.threshold = reader.int32();
                    break;
                case /* brandguard.kernel.VideoKernelScoringEnabled brand_voice = 3 [json_name = "brand_voice"];*/ 3:
                    message.brand_voice = VideoKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.brand_voice);
                    break;
                case /* brandguard.kernel.VideoKernelScoringEnabled sexually_explicit = 4 [json_name = "sexually_explicit"];*/ 4:
                    message.sexually_explicit = VideoKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.sexually_explicit);
                    break;
                case /* brandguard.kernel.VideoKernelScoringEnabled video_quality_general = 5 [json_name = "quality_general"];*/ 5:
                    message.video_quality_general = VideoKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.video_quality_general);
                    break;
                case /* brandguard.kernel.VideoKernelScoringEnabled video_violence = 6 [json_name = "video_violence"];*/ 6:
                    message.video_violence = VideoKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.video_violence);
                    break;
                case /* brandguard.kernel.VideoKernelLogosEnabled video_logo_detection = 7 [json_name = "video_logo_detection"];*/ 7:
                    message.video_logo_detection = VideoKernelLogosEnabled.internalBinaryRead(reader, reader.uint32(), options, message.video_logo_detection);
                    break;
                case /* brandguard.kernel.VideoKernelLookandFeelEnabled video_lookandfeel = 8 [json_name = "video_lookandfeel"];*/ 8:
                    message.video_lookandfeel = VideoKernelLookandFeelEnabled.internalBinaryRead(reader, reader.uint32(), options, message.video_lookandfeel);
                    break;
                case /* brandguard.kernel.VideoKernelFontEnabled video_font_detection = 9 [json_name = "video_font_detection"];*/ 9:
                    message.video_font_detection = VideoKernelFontEnabled.internalBinaryRead(reader, reader.uint32(), options, message.video_font_detection);
                    break;
                case /* brandguard.kernel.VideoKernelBackgroundColorEnabled video_background_colors = 10 [json_name = "video_background_colors"];*/ 10:
                    message.video_background_colors = VideoKernelBackgroundColorEnabled.internalBinaryRead(reader, reader.uint32(), options, message.video_background_colors);
                    break;
                case /* brandguard.kernel.VideoKernelScoringEnabled brand_consistency = 11 [json_name = "brand_consistency"];*/ 11:
                    message.brand_consistency = VideoKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.brand_consistency);
                    break;
                case /* brandguard.kernel.VideoKernelProductDetection product_detection = 12 [json_name = "product_detection"];*/ 12:
                    message.product_detection = VideoKernelProductDetection.internalBinaryRead(reader, reader.uint32(), options, message.product_detection);
                    break;
                case /* brandguard.kernel.VideoKernelScoringEnabled ai_generated = 13 [json_name = "ai_generated"];*/ 13:
                    message.ai_generated = VideoKernelScoringEnabled.internalBinaryRead(reader, reader.uint32(), options, message.ai_generated);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelSetting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1 [json_name = "kernel_id"]; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* int32 threshold = 2; */
        if (message.threshold !== 0)
            writer.tag(2, WireType.Varint).int32(message.threshold);
        /* brandguard.kernel.VideoKernelScoringEnabled brand_voice = 3 [json_name = "brand_voice"]; */
        if (message.brand_voice)
            VideoKernelScoringEnabled.internalBinaryWrite(message.brand_voice, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelScoringEnabled sexually_explicit = 4 [json_name = "sexually_explicit"]; */
        if (message.sexually_explicit)
            VideoKernelScoringEnabled.internalBinaryWrite(message.sexually_explicit, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelScoringEnabled video_quality_general = 5 [json_name = "quality_general"]; */
        if (message.video_quality_general)
            VideoKernelScoringEnabled.internalBinaryWrite(message.video_quality_general, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelScoringEnabled video_violence = 6 [json_name = "video_violence"]; */
        if (message.video_violence)
            VideoKernelScoringEnabled.internalBinaryWrite(message.video_violence, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelLogosEnabled video_logo_detection = 7 [json_name = "video_logo_detection"]; */
        if (message.video_logo_detection)
            VideoKernelLogosEnabled.internalBinaryWrite(message.video_logo_detection, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelLookandFeelEnabled video_lookandfeel = 8 [json_name = "video_lookandfeel"]; */
        if (message.video_lookandfeel)
            VideoKernelLookandFeelEnabled.internalBinaryWrite(message.video_lookandfeel, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelFontEnabled video_font_detection = 9 [json_name = "video_font_detection"]; */
        if (message.video_font_detection)
            VideoKernelFontEnabled.internalBinaryWrite(message.video_font_detection, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelBackgroundColorEnabled video_background_colors = 10 [json_name = "video_background_colors"]; */
        if (message.video_background_colors)
            VideoKernelBackgroundColorEnabled.internalBinaryWrite(message.video_background_colors, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelScoringEnabled brand_consistency = 11 [json_name = "brand_consistency"]; */
        if (message.brand_consistency)
            VideoKernelScoringEnabled.internalBinaryWrite(message.brand_consistency, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelProductDetection product_detection = 12 [json_name = "product_detection"]; */
        if (message.product_detection)
            VideoKernelProductDetection.internalBinaryWrite(message.product_detection, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.kernel.VideoKernelScoringEnabled ai_generated = 13 [json_name = "ai_generated"]; */
        if (message.ai_generated)
            VideoKernelScoringEnabled.internalBinaryWrite(message.ai_generated, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.kernel.VideoKernelSetting
 */
export const VideoKernelSetting = new VideoKernelSetting$Type();
